// Helpers partagés pour la gestion de documents (commentaires litiges, JDMA, etc.)

let _pdfjsLib = null;

export async function getPdfjsLib() {
  if (!_pdfjsLib) {
    _pdfjsLib = await import('pdfjs-dist/legacy/build/pdf');
    _pdfjsLib.GlobalWorkerOptions.workerSrc =
      '//unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js';
  }
  return _pdfjsLib;
}

export const normalizeDoc = (d) => ({
  ...d,
  name: d.name || d.nom,
  type: d.type || d.type_mime,
});

export async function compressFile(file) {
  if (!file.type.startsWith('image/')) return file;
  return new Promise((resolve) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      const MAX = 1600;
      let { width, height } = img;
      if (width > MAX || height > MAX) {
        const ratio = Math.min(MAX / width, MAX / height);
        width  = Math.round(width  * ratio);
        height = Math.round(height * ratio);
      }
      const canvas = document.createElement('canvas');
      canvas.width  = width;
      canvas.height = height;
      canvas.getContext('2d').drawImage(img, 0, 0, width, height);
      canvas.toBlob(
        (blob) => {
          if (!blob || blob.size >= file.size) resolve(file);
          else resolve(new File([blob], file.name, { type: 'image/jpeg', lastModified: Date.now() }));
        },
        'image/jpeg',
        0.82
      );
    };
    img.onerror = () => { URL.revokeObjectURL(objectUrl); resolve(file); };
    img.src = objectUrl;
  });
}

export async function compressPdfClientSide(file) {
  try {
    const [{ PDFDocument }, pdfjs] = await Promise.all([
      import('pdf-lib'),
      getPdfjsLib(),
    ]);

    const arrayBuffer = await file.arrayBuffer();
    const srcPdf = await pdfjs.getDocument({ data: new Uint8Array(arrayBuffer) }).promise;
    const numPages = srcPdf.numPages;
    const outDoc  = await PDFDocument.create();

    const SCALE  = 2.0;
    const JPEG_Q = 0.75;

    for (let i = 1; i <= numPages; i++) {
      const page     = await srcPdf.getPage(i);
      const viewport = page.getViewport({ scale: SCALE });
      const canvas   = document.createElement('canvas');
      canvas.width   = Math.round(viewport.width);
      canvas.height  = Math.round(viewport.height);
      await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;

      const jpegBlob  = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', JPEG_Q));
      const jpegBytes = new Uint8Array(await jpegBlob.arrayBuffer());
      const jpegImage = await outDoc.embedJpg(jpegBytes);
      const pdfPage   = outDoc.addPage([canvas.width, canvas.height]);
      pdfPage.drawImage(jpegImage, { x: 0, y: 0, width: canvas.width, height: canvas.height });
    }

    const compressedBytes = await outDoc.save({ useObjectStreams: true });
    const compressedFile  = new File([compressedBytes], file.name, {
      type: 'application/pdf', lastModified: Date.now(),
    });
    return compressedFile.size < file.size ? compressedFile : file;
  } catch (e) {
    console.warn('PDF compression skipped:', e.message);
    return file;
  }
}
